import { Link } from 'react-router-dom';
import { AppHeader } from '../components/AppHeader';
import { useAuth } from '../lib/auth';

export function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;

  const isStaff = user.role !== 'super_admin';

  return (
    <main className="app-shell">
      <AppHeader backTo={null} />
      <section className="app-shell__main">
        <div className="dashboard-grid">
          <div className="app-shell__card dashboard-greeting">
            <div className="app-shell__card-label">
              {user.branding.tenant_slug
                ? `TENANT · ${user.branding.tenant_slug.toUpperCase()}`
                : 'SUPER-ADMIN · CROSS-TENANT'}
            </div>
            <h1 className="app-shell__card-title">
              Willkommen, {user.full_name.split(' ')[0]}
            </h1>
            {user.branding.tenant_name ? (
              <p className="app-shell__card-meta">{user.branding.tenant_name}</p>
            ) : null}
          </div>

          {isStaff && (
            <Link to="/capture" className="dashboard-tile dashboard-tile--primary">
              <div className="dashboard-tile__label">LEAD-ERFASSUNG</div>
              <div className="dashboard-tile__title">Neuen Lead aufnehmen</div>
              <div className="dashboard-tile__arrow">→</div>
            </Link>
          )}

          <Link to="/leads" className="dashboard-tile">
            <div className="dashboard-tile__label">LEADS</div>
            <div className="dashboard-tile__title">Übersicht + Excel-Export</div>
            <div className="dashboard-tile__arrow">→</div>
          </Link>

          <Link to="/users" className="dashboard-tile">
            <div className="dashboard-tile__label">MITARBEITER</div>
            <div className="dashboard-tile__title">Team-Übersicht</div>
            <div className="dashboard-tile__arrow">→</div>
          </Link>

          {/* Sprint 45 · Microsoft-Anbindung-Tile nur für super_admin
              (Phase 1: globale messe@-Mailbox · operator_admin verwaltet
              die nicht). Form-Builder-Tile bleibt für operator_admin sichtbar. */}
          {user.role === 'super_admin' && (
            <Link to="/settings/mail" className="dashboard-tile">
              <div className="dashboard-tile__label">SETTINGS · MAIL</div>
              <div className="dashboard-tile__title">Microsoft-Anbindung</div>
              <div className="dashboard-tile__arrow">→</div>
            </Link>
          )}
          {(user.role === 'operator_admin' || user.role === 'super_admin') && (
            <Link to="/admin/forms" className="dashboard-tile">
              <div className="dashboard-tile__label">ERFASSUNGS-FORM</div>
              <div className="dashboard-tile__title">Form-Builder</div>
              <div className="dashboard-tile__arrow">→</div>
            </Link>
          )}

          {user.role === 'super_admin' && (
            <>
              <Link to="/admin/tenants" className="dashboard-tile">
                <div className="dashboard-tile__label">SUPER-ADMIN</div>
                <div className="dashboard-tile__title">Mandanten-Verwaltung</div>
                <div className="dashboard-tile__arrow">→</div>
              </Link>
              <Link to="/admin/health" className="dashboard-tile">
                <div className="dashboard-tile__label">SYSTEM</div>
                <div className="dashboard-tile__title">System-Health</div>
                <div className="dashboard-tile__arrow">→</div>
              </Link>
              <Link to="/admin/ai-usage" className="dashboard-tile">
                <div className="dashboard-tile__label">AI · COSTS</div>
                <div className="dashboard-tile__title">OpenAI-Kosten</div>
                <div className="dashboard-tile__arrow">→</div>
              </Link>
            </>
          )}
        </div>
      </section>
    </main>
  );
}
